type QueueWithOptionalName = { Name?: string };

const getQueueName = <TQueue extends QueueWithOptionalName>({ Name }: TQueue) => Name || '';

// Used when the current interaction has no filter: remove queues claimed by other configured filters.
const matchesAnyPattern = <TQueue extends QueueWithOptionalName>(queue: TQueue, patterns: RegExp[]) => {
  const queueName = getQueueName(queue);

  return patterns.some((pattern) => pattern.test(queueName));
};

export const applyQueueNameRegexFilter = <TQueue extends QueueWithOptionalName>({
  queues,
  pattern,
  excludedPatterns = [],
}: {
  queues: TQueue[];
  pattern?: RegExp | null;
  excludedPatterns?: RegExp[];
}): TQueue[] => {
  // `undefined` means “no filter configured”, 
  // `null` means “filter was configured but invalid” eg: "["
  // `getQueueFilterPatternForInteractionType` returns `undefined` for blank filters, 
  // and `null` for invalid filters.
  const hasNoCurrentPattern = pattern === undefined;
  const hasInvalidCurrentPattern = pattern === null;

  if (hasNoCurrentPattern && !excludedPatterns.length) {
    return queues;
  }

  if (hasNoCurrentPattern) {
    return queues.filter((queue) => !matchesAnyPattern(queue, excludedPatterns));
  }

  if (hasInvalidCurrentPattern) {
    return [];
  }

  return queues.filter((queue) => pattern.test(getQueueName(queue)));
};
